import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { groupBy } from "../../../../utils";

export interface ProductLocationsData {
  serialNumber: string;
  warehouseLocation: string;
}

const SerialNumberLocations = ({ productCode }: { productCode: string }) => {
  const [productLocationsData, setProductLocationsData] = useState<
    ProductLocationsData[]
  >([]);

  const groupedLocations = groupBy(productLocationsData, "warehouseLocation");

  useEffect(() => {
    axios
      .get(`/products/locations?productCode=${productCode}`)
      .then((response) => {
        setProductLocationsData(response.data?.items ?? []);
      });
  }, [productCode]);

  return (
    <TableContainer>
      <Table
        sx={{
          table: {
            minWidth: 650,
          },
        }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow>
            <TableCell>Ubicazione</TableCell>
            <TableCell>Prodotti</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {productLocationsData &&
            Object.keys(groupedLocations).map((location, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  <b>{location === "null" ? "SENZA UBICAZIONE" : location}</b>
                </TableCell>
                <TableCell component="th" scope="row">
                  {groupedLocations[location]?.length} pz
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SerialNumberLocations;
